
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jD7cj", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $a3fRD = parcelRequire("a3fRD");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");

const $1a5862e35fde8197$var$errorMessageWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'space.050'
});
const $1a5862e35fde8197$var$errorMessageTextStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    color: 'color.text.accent.red'
});
const $1a5862e35fde8197$export$1834f1a788ceaae3 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1a5862e35fde8197$var$errorMessageWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                color: "var(--ds-icon-accent-red, #C9372C)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                xcss: $1a5862e35fde8197$var$errorMessageTextStyles,
                children: children
            })
        ]
    });
module.exports["FormFieldErrorMessage"] = $1a5862e35fde8197$export$1834f1a788ceaae3;

});

parcelRegister("3v7tz", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $090a5a412e4e42e1$export$c17cf6b332a82dbc = (0, $42omo.createContext)(false);
const $090a5a412e4e42e1$export$84e4f1713c208255 = ()=>(0, $42omo.useContext)($090a5a412e4e42e1$export$c17cf6b332a82dbc);
module.exports["IsDisabledContext"] = $090a5a412e4e42e1$export$c17cf6b332a82dbc;
module.exports["useIsDisabledContext"] = $090a5a412e4e42e1$export$84e4f1713c208255;

});

parcelRegister("eNm9g", function(module, exports) {
const $87b7d5624e5ee502$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $87b7d5624e5ee502$export$c23d8af8b1b8f2d7 = async (queryWord, pageNumber, submitError, shouldUseFullSizeImage)=>{
    try {
        const response = await fetch(`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Received status ${response.status}`);
        const responseData = await response.json();
        return responseData.results?.map((result)=>({
                id: result.id,
                altDescription: result.alt_description,
                smallSizeImageUrl: result.urls.thumb,
                fullSizeImageUrl: shouldUseFullSizeImage ? result.urls.full : result.urls.regular,
                artistName: result.user.name,
                artistUrl: result.user.links.html + $87b7d5624e5ee502$export$535fddacdd1506a3,
                downloadLink: result.links.download_location
            }));
    } catch (error) {
        const err = error instanceof Error ? error : new Error('An unknown error occurred');
        submitError?.(err);
        throw err;
    }
};
module.exports["getUnsplashPhotos"] = $87b7d5624e5ee502$export$c23d8af8b1b8f2d7;

});

parcelRegister("jCIc5", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3v7tz = parcelRequire("3v7tz");

const $082555c11bb18b57$var$panelSubheaderStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $082555c11bb18b57$var$panelSubheaderDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'not-allowed'
    }
});
const $082555c11bb18b57$export$12228125ac99294 = ({ children: children, showUpdatedStyles: showUpdatedStyles = false })=>{
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $082555c11bb18b57$var$panelSubheaderStyles,
            isDisabled && $082555c11bb18b57$var$panelSubheaderDisabledStyles
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
            size: showUpdatedStyles ? 'medium' : 'small',
            weight: showUpdatedStyles ? 'regular' : 'bold',
            color: showUpdatedStyles ? 'color.text' : 'inherit',
            children: children
        })
    });
};
module.exports["PanelSubheader"] = $082555c11bb18b57$export$12228125ac99294;

});

parcelRegister("azUhE", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gQhRa = parcelRequire("gQhRa");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $cdb83b989b0de607$var$helperMessageWrapperStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100',
    display: 'flex',
    justifyContent: 'space-between'
});
const $cdb83b989b0de607$var$helperMessageDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled'
});
const $cdb83b989b0de607$export$f3270c9ea239a57e = ({ helperMessage: helperMessage, isDisabled: isDisabled })=>helperMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $cdb83b989b0de607$var$helperMessageWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: isDisabled ? $cdb83b989b0de607$var$helperMessageDisabledStyles : undefined,
                children: helperMessage
            })
        })
    }) : null;
module.exports["MediaContentHelperMessage"] = $cdb83b989b0de607$export$f3270c9ea239a57e;

});

parcelRegister("6YdGV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7FcUt = parcelRequire("7FcUt");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $3v7tz = parcelRequire("3v7tz");




parcelRequire("42omo");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");

const $391674b69d1174a5$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $391674b69d1174a5$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $391674b69d1174a5$var$canBeSelectedStyles = (0, $ecnYn.xcss)({
    cursor: 'auto'
});
const $391674b69d1174a5$export$58ac8acf6266d241 = ({ image: image, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        "aria-pressed": isSelected,
        xcss: [
            $391674b69d1174a5$var$baseStyles,
            canBeSelected && $391674b69d1174a5$var$canBeSelectedStyles,
            isSelected && $391674b69d1174a5$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick,
        children: children
    }, `${image} ${isSelected ? '1' : '0'}`);
};




parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");








const $0745015b00628052$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noImageLabel: {
        id: "company-hub.company-hub-common.unsplash-search.default-image-picker.no-image",
        defaultMessage: "No image"
    }
});


const $094fc646e609702b$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative'
});
const $094fc646e609702b$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $094fc646e609702b$var$noImageStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    position: 'relative'
});
const $094fc646e609702b$var$noImageLineStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: '50%',
    top: '5%',
    height: '90%',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    rotate: '45deg'
});
const $094fc646e609702b$export$8b9fdf0a6bb637af = ({ onClick: onClick, isSelected: isSelected, children: children })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2W0qg.default), {
        xcss: [
            $094fc646e609702b$var$baseStyles,
            $094fc646e609702b$var$noImageStyles,
            isSelected && $094fc646e609702b$var$selectedStyles
        ],
        testId: "unsplash-no-image",
        "aria-label": intl.formatMessage((0, $0745015b00628052$export$defe85febe8b728c).noImageLabel),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $094fc646e609702b$var$noImageLineStyles
            }),
            children
        ]
    });
};




parcelRequire("42omo");






const $6ddc89ec04b247e4$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none'
});
const $6ddc89ec04b247e4$var$placeholderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $6ddc89ec04b247e4$export$e327f3d4c8672489 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $6ddc89ec04b247e4$var$baseStyles,
            $6ddc89ec04b247e4$var$placeholderStyles
        ],
        testId: "image-picker-placeholders"
    });
};




parcelRequire("42omo");






const $5571be2f163574a1$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'radius.small',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $5571be2f163574a1$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #1868DB)"}`
});
const $5571be2f163574a1$var$canBeSelectedStyles = (0, $ecnYn.xcss)({
    cursor: 'auto'
});
const $5571be2f163574a1$export$99fc49c7c3f55eda = ({ image: image, description: description, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        "aria-pressed": isSelected,
        "aria-label": description,
        xcss: [
            $5571be2f163574a1$var$baseStyles,
            canBeSelected && $5571be2f163574a1$var$canBeSelectedStyles,
            isSelected && $5571be2f163574a1$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick,
        children: children
    }, `${image} ${isSelected ? '1' : '0'}`);
};

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $1Whri = parcelRequire("1Whri");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $btHGY = parcelRequire("btHGY");


var $fVUfS = parcelRequire("fVUfS");


var $fOKpq = parcelRequire("fOKpq");





const $5c708a359eb811d9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    uploadImageFailedDescription: {
        id: "company-hub.company-hub-common.shared-components.unsplash-search.upload.error.description",
        defaultMessage: "Refresh the page and try again"
    },
    uploadImageFailedTitle: {
        id: "company-hub.company-hub-common.shared-components.unsplash-search.upload.error.title",
        defaultMessage: "Image failed to load"
    }
});


const $216954b598318022$var$IMAGE_CONFIGURATION = {
    allowAnimated: true,
    mode: 'full-fit',
    upscale: false
};
const $216954b598318022$var$styles = {
    base: "_2rko12b0 _19itglyw _4t3i1ylp _1bsb1ady _kqswh2mm _1lrw1dfr _ouxl1ssb _12vemgnk",
    selected: "_16qszp5g"
};
const $216954b598318022$export$94984c14ad3e5368 = ({ contentId: contentId, imageId: imageId, isSelected: isSelected, onClick: onClick, children: children, mediaConfigOverride: mediaConfigOverride })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useMediaConfig: useMediaConfig } = (0, $fOKpq.useProductDependencies)();
    const { authProvider: authProvider, collection: collection, fileId: fileId } = useMediaConfig?.({
        contentId: contentId,
        imageSrc: imageId
    }) || {};
    let resolvedAuthProvider = authProvider;
    let resolvedCollection = collection;
    if (mediaConfigOverride?.authProvider && mediaConfigOverride?.collection) {
        resolvedAuthProvider = mediaConfigOverride.authProvider;
        resolvedCollection = mediaConfigOverride.collection;
    }
    const identifier = (0, $42omo.useMemo)(()=>({
            mediaItemType: 'file',
            id: fileId ?? '',
            collectionName: resolvedCollection
        }), [
        fileId,
        resolvedCollection
    ]);
    if (!resolvedAuthProvider || !resolvedCollection || !fileId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $btHGY.MediaImageWithErrorBoundary //force rerender image on id change until https://product-fabric.atlassian.net/browse/CXP-2899 is fixed
    ), {
        identifier: identifier,
        mediaClientConfig: {
            authProvider: resolvedAuthProvider
        },
        apiConfig: $216954b598318022$var$IMAGE_CONFIGURATION,
        children: ({ data: data, loading: loading, error: error })=>{
            if (loading || !data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {});
            if (error) {
                showFlag({
                    id: 'upload-image-error',
                    title: formatMessage((0, $5c708a359eb811d9$export$defe85febe8b728c).uploadImageFailedTitle),
                    description: formatMessage((0, $5c708a359eb811d9$export$defe85febe8b728c).uploadImageFailedDescription),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        label: "",
                        color: "var(--ds-icon-danger, #C9372C)"
                    })
                });
                createAnalyticsEvent({
                    type: 'error',
                    data: {
                        actionSubject: 'image',
                        actionSubjectId: 'coverImageSelected',
                        source: 'coverImageSelectedComponent'
                    }
                }).fire();
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {});
            }
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: (0, $1Whri.cx)($216954b598318022$var$styles.base, isSelected && $216954b598318022$var$styles.selected),
                style: {
                    backgroundImage: `url(${data.src})`
                },
                onClick: onClick,
                testId: "uploaded-image-thumbnail",
                children: children
            });
        }
    }, fileId);
};


var $7954d70d7abc7d53$export$bc1779d8140a60be = /*#__PURE__*/ function(ThumbnailType) {
    ThumbnailType[ThumbnailType["UNSPLASH_DEFAULT_IMAGE"] = 0] = "UNSPLASH_DEFAULT_IMAGE";
    ThumbnailType[ThumbnailType["UNSPLASH_IMAGE"] = 1] = "UNSPLASH_IMAGE";
    ThumbnailType[ThumbnailType["CUSTOM_IMAGE"] = 2] = "CUSTOM_IMAGE";
    ThumbnailType[ThumbnailType["EXTERNAL_SITE_IMAGE"] = 3] = "EXTERNAL_SITE_IMAGE";
    ThumbnailType[ThumbnailType["NO_IMAGE"] = 4] = "NO_IMAGE";
    return ThumbnailType;
}({});




var $iqWjJ = parcelRequire("iqWjJ");

const $82a70f709104df03$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $82a70f709104df03$var$createCustomImageThumbnail = (imageId)=>({
        type: (0, $7954d70d7abc7d53$export$bc1779d8140a60be).CUSTOM_IMAGE,
        image: {
            imageId: imageId
        }
    });
const $82a70f709104df03$export$7f2b17edc08bf65b = (image)=>({
        type: (0, $7954d70d7abc7d53$export$bc1779d8140a60be).UNSPLASH_DEFAULT_IMAGE,
        image: image
    });
const $82a70f709104df03$var$createUnsplashImageThumbnail = (url, altText)=>({
        type: (0, $7954d70d7abc7d53$export$bc1779d8140a60be).UNSPLASH_IMAGE,
        image: {
            fullSizeImageUrl: url,
            altDescription: altText
        }
    });
const $82a70f709104df03$var$createExternalSiteImageThumbnail = (url)=>({
        type: (0, $7954d70d7abc7d53$export$bc1779d8140a60be).EXTERNAL_SITE_IMAGE,
        image: url
    });
const $82a70f709104df03$var$initialUnsplashResultsIncludes = ({ image: image, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed })=>{
    if (!initialUnsplashResults?.length) return false;
    const adjustedUnsplashResults = isNoImageAllowed ? initialUnsplashResults.slice(2) : initialUnsplashResults.slice(1);
    return adjustedUnsplashResults.map((result)=>result.fullSizeImageUrl).includes(image || '');
};
const $82a70f709104df03$var$getFirstImageWhenSelectedImageIsUnsplash = ({ selectedImageUrl: selectedImageUrl, firstImage: firstImage, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    const isSelectedUnsplashInInitialResults = (image = selectedImageUrl)=>$82a70f709104df03$var$initialUnsplashResultsIncludes({
            image: image,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed
        });
    // if selected unsplash image is not in initial results array, then it should always be in the
    // first thumbnail
    if (!isSelectedUnsplashInInitialResults()) return $82a70f709104df03$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    // TODO: this code can be removed when UnsplashSearch is replaced by MediaPickerContent
    const currentFirstImageUnsplash = firstImage?.current?.image && typeof firstImage?.current?.image !== 'string' && 'fullSizeImageUrl' in firstImage.current.image && (0, $iqWjJ.isUnsplashImage)(firstImage.current.image.fullSizeImageUrl) && firstImage?.current?.image?.fullSizeImageUrl;
    if (currentFirstImageUnsplash && selectedImageUrl !== currentFirstImageUnsplash) {
        if (!isSelectedUnsplashInInitialResults(currentFirstImageUnsplash) && isSelectedUnsplashInInitialResults()) return $82a70f709104df03$var$createUnsplashImageThumbnail(currentFirstImageUnsplash, imageAltText);
        if (!isSelectedUnsplashInInitialResults()) return $82a70f709104df03$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (previewUploadedImageId && firstImage.current?.image === previewUploadedImageId) {
        if (isSelectedUnsplashInInitialResults()) return firstImage.current;
        if (!isSelectedUnsplashInInitialResults()) return $82a70f709104df03$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (firstImage?.current?.image && typeof firstImage.current.image !== 'string' && 'imageId' in firstImage.current.image && isSelectedUnsplashInInitialResults()) return firstImage.current;
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId && initialUploadedImageId) return $82a70f709104df03$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId) return $82a70f709104df03$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && initialUnsplashResults?.length) return $82a70f709104df03$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $82a70f709104df03$export$7f2b17edc08bf65b();
};
const $82a70f709104df03$export$e3511fb9079c14da = ({ selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, firstImage: firstImage, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    if (selectedImageUrl) {
        if ((0, $iqWjJ.isUnsplashImage)(selectedImageUrl)) return $82a70f709104df03$var$getFirstImageWhenSelectedImageIsUnsplash({
            selectedImageUrl: selectedImageUrl,
            firstImage: firstImage,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed,
            previewUploadedImageId: previewUploadedImageId,
            initialUploadedImageId: initialUploadedImageId,
            imageAltText: imageAltText
        });
        else {
            if ($82a70f709104df03$var$externalSiteMatcher.test(selectedImageUrl)) return $82a70f709104df03$var$createExternalSiteImageThumbnail(selectedImageUrl);
            return $82a70f709104df03$var$createCustomImageThumbnail(selectedImageUrl);
        }
    }
    if (initialUploadedImageId) return $82a70f709104df03$var$createCustomImageThumbnail(initialUploadedImageId);
    if (initialUnsplashResults?.length) return $82a70f709104df03$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $82a70f709104df03$export$7f2b17edc08bf65b();
};


const $491528c31af83b13$var$styles = {
    imagesWrapper: "_19pku2gc _1bah1yb4 _ca0qze3t",
    checkboxWrapper: "_kqswh2mm",
    selectedImageTick: "_kqswstnw _94n5ze3t _1xi2ze3t _1kt9b3bt _1rusysee _kfgt1ssb _1mp41ssb _1cs8stnw _ooun1b66 _1auk1b66"
};
const $491528c31af83b13$var$isUnsplashDefaultImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $7954d70d7abc7d53$export$bc1779d8140a60be).UNSPLASH_DEFAULT_IMAGE;
};
const $491528c31af83b13$var$isUnsplashImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $7954d70d7abc7d53$export$bc1779d8140a60be).UNSPLASH_IMAGE;
};
const $491528c31af83b13$var$isCustomImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $7954d70d7abc7d53$export$bc1779d8140a60be).CUSTOM_IMAGE;
};
const $491528c31af83b13$var$isExternalSiteImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $7954d70d7abc7d53$export$bc1779d8140a60be).EXTERNAL_SITE_IMAGE;
};
const $491528c31af83b13$var$isNoImageThumbnail = (thumbnail)=>{
    return thumbnail.type === (0, $7954d70d7abc7d53$export$bc1779d8140a60be).NO_IMAGE;
};
const $491528c31af83b13$var$createNoImageThumbnail = ()=>({
        type: (0, $7954d70d7abc7d53$export$bc1779d8140a60be).NO_IMAGE,
        image: undefined
    });
const $491528c31af83b13$export$71256286fd384466 = ()=>{
    return Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {}, index));
};
const $491528c31af83b13$export$62a2f85610ce8d51 = ({ contentId: contentId, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, handleImageSelection: handleImageSelection, initialUnsplashResults: initialUnsplashResults, analyticsSource: analyticsSource, isUploadingImage: isUploadingImage, isNoImageAllowed: isNoImageAllowed, initialUploadedImageId: initialUploadedImageId, previewUploadedImageId: previewUploadedImageId, mediaConfigOverride: mediaConfigOverride })=>{
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onImageClick = (0, $42omo.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        if (!isUploadingImage) {
            handleImageSelection({
                fullSizeImageUrl: fullSizeImageUrl,
                altDescription: altDescription,
                downloadLink: downloadLink
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'unsplashDefault'
                    }
                }
            }).fire();
        }
    }, [
        analyticsSource,
        createAnalyticsEvent,
        handleImageSelection,
        isUploadingImage
    ]);
    const renderCheckboxIcon = (0, $42omo.useCallback)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $491528c31af83b13$var$styles.selectedImageTick,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                xcss: $491528c31af83b13$var$styles.checkboxWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FcUt))), {
                    label: "checkmark",
                    color: "var(--ds-icon-brand, #1868DB)"
                })
            })
        });
    }, []);
    const renderGenericUnsplashImage = (0, $42omo.useCallback)(({ smallSizeImageUrl: smallSizeImageUrl, fullSizeImageUrl: fullSizeImageUrl, description: description, isSelected: isSelected, index: index, downloadLink: downloadLink })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5571be2f163574a1$export$99fc49c7c3f55eda), {
            image: smallSizeImageUrl,
            description: description,
            isSelected: isSelected,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: fullSizeImageUrl,
                    altDescription: description,
                    downloadLink: downloadLink
                }),
            children: isSelected && renderCheckboxIcon()
        }, `thumbnail-${index}`);
    }, [
        isUploadingImage,
        onImageClick,
        renderCheckboxIcon
    ]);
    const renderUnsplashDefaultImage = (0, $42omo.useCallback)((image, index)=>{
        const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink, smallSizeImageUrl: smallSizeImageUrl } = image;
        const isSelected = fullSizeImageUrl === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: smallSizeImageUrl ?? fullSizeImageUrl,
            fullSizeImageUrl: fullSizeImageUrl,
            description: altDescription,
            isSelected: isSelected,
            index: index,
            downloadLink: downloadLink
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderUnsplashImage = (0, $42omo.useCallback)((image, index)=>{
        const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription } = image;
        const isSelected = fullSizeImageUrl === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: fullSizeImageUrl,
            fullSizeImageUrl: fullSizeImageUrl,
            description: altDescription ?? '',
            isSelected: isSelected,
            index: index,
            downloadLink: undefined
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderExternalSiteImage = (0, $42omo.useCallback)((image, index)=>{
        const isSelectedImage = image === selectedImageUrl;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $391674b69d1174a5$export$58ac8acf6266d241), {
            image: image,
            isSelected: isSelectedImage,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: image,
                    altDescription: ''
                }),
            children: isSelectedImage && renderCheckboxIcon()
        }, `thumbnail-${index}`);
    }, [
        selectedImageUrl,
        isUploadingImage,
        renderCheckboxIcon,
        onImageClick
    ]);
    const renderUploadedImage = (0, $42omo.useCallback)((image, index)=>{
        const { imageId: imageId } = image;
        const isSelectedImage = imageId === selectedImageUrl && index === 0;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $216954b598318022$export$94984c14ad3e5368), {
            contentId: contentId,
            imageId: imageId,
            isSelected: isSelectedImage,
            mediaConfigOverride: mediaConfigOverride,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: imageId,
                    altDescription: ''
                }),
            children: isSelectedImage && renderCheckboxIcon()
        }, `thumbnail-${index}`);
    }, [
        selectedImageUrl,
        contentId,
        onImageClick,
        renderCheckboxIcon,
        mediaConfigOverride
    ]);
    const renderNoImageThumbnail = (0, $42omo.useCallback)((index)=>{
        const isSelected = selectedImageUrl === '';
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $094fc646e609702b$export$8b9fdf0a6bb637af), {
            isSelected: isSelected,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: '',
                    altDescription: ''
                }),
            children: isSelected && renderCheckboxIcon()
        }, index);
    }, [
        selectedImageUrl,
        onImageClick,
        renderCheckboxIcon
    ]);
    const firstImage = (0, $42omo.useRef)();
    firstImage.current = (0, $82a70f709104df03$export$e3511fb9079c14da)({
        selectedImageUrl: selectedImageUrl,
        initialUnsplashResults: initialUnsplashResults,
        isNoImageAllowed: isNoImageAllowed,
        firstImage: firstImage,
        previewUploadedImageId: previewUploadedImageId,
        initialUploadedImageId: initialUploadedImageId,
        imageAltText: imageAltText
    });
    const secondImage = isNoImageAllowed ? $491528c31af83b13$var$createNoImageThumbnail() : (0, $82a70f709104df03$export$7f2b17edc08bf65b)(initialUnsplashResults?.[1]);
    const imagesToDisplay = [
        firstImage.current,
        secondImage,
        (0, $82a70f709104df03$export$7f2b17edc08bf65b)(initialUnsplashResults?.[2]),
        (0, $82a70f709104df03$export$7f2b17edc08bf65b)(initialUnsplashResults?.[3]),
        (0, $82a70f709104df03$export$7f2b17edc08bf65b)(initialUnsplashResults?.[4])
    ];
    const renderThumbnails = (0, $42omo.useCallback)((thumbnail, index)=>{
        // Ordering matters for first image rendering logic
        if ($491528c31af83b13$var$isNoImageThumbnail(thumbnail)) return renderNoImageThumbnail(index);
        if (!thumbnail.image) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {}, index);
        if ($491528c31af83b13$var$isUnsplashDefaultImageThumbnail(thumbnail)) return renderUnsplashDefaultImage(thumbnail.image, index);
        if ($491528c31af83b13$var$isUnsplashImageThumbnail(thumbnail)) return renderUnsplashImage(thumbnail.image, index);
        if ($491528c31af83b13$var$isExternalSiteImageThumbnail(thumbnail)) return renderExternalSiteImage(thumbnail.image, index);
        if ($491528c31af83b13$var$isCustomImageThumbnail(thumbnail)) return renderUploadedImage(thumbnail.image, index);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ddc89ec04b247e4$export$e327f3d4c8672489), {}, index);
    }, [
        renderNoImageThumbnail,
        renderUnsplashDefaultImage,
        renderUnsplashImage,
        renderUploadedImage,
        renderExternalSiteImage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $491528c31af83b13$var$styles.imagesWrapper,
        testId: "default-image-picker",
        children: isDisabled ? $491528c31af83b13$export$71256286fd384466() : imagesToDisplay.map(renderThumbnails)
    });
};
module.exports["DefaultImagePicker"] = $491528c31af83b13$export$62a2f85610ce8d51;

});

parcelRegister("h3Ebw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $jluld = parcelRequire("jluld");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4noo5 = parcelRequire("4noo5");


var $3v7tz = parcelRequire("3v7tz");


var $fOKpq = parcelRequire("fOKpq");


var $2Maq7 = parcelRequire("2Maq7");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");








var $9YwaJ = parcelRequire("9YwaJ");


var $gj7hi = parcelRequire("gj7hi");




var $5f0e5a5917169067$exports = {};
$5f0e5a5917169067$exports = new URL("NoResults.9d75157a.svg", import.meta.url).toString();






var $eNm9g = parcelRequire("eNm9g");




const $3b75a366b1d2a3f7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unsplashNoResultsText: {
        id: "company-hub.company-hub-common.unsplash.search.no.results.text",
        defaultMessage: "Nothing matches your search"
    },
    unsplashLoadMoreAriaLabel: {
        id: "company-hub.company-hub-common.unsplash.search.load-more.aria-label",
        defaultMessage: "Load more header images"
    },
    unsplashNoMoreResultsToLoadText: {
        id: "company-hub.company-hub-common.unsplash.search.no.more.results.to.load.text",
        defaultMessage: "No more matches try another search"
    },
    unsplashLegal: {
        id: "company-hub.company-hub-common.unsplash.legal",
        defaultMessage: "By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}."
    },
    unsplashLicenseLink: {
        id: "company-hub.company-hub-common.unsplash.license",
        defaultMessage: "license"
    },
    unsplashTermsOfServiceLink: {
        id: "company-hub.company-hub-common.unsplash.terms.of.service.",
        defaultMessage: "Terms of Service"
    }
});


const $d53659c85faac35b$var$UNSPLASH_LICENSE_LINK = 'https://unsplash.com/license';
const $d53659c85faac35b$var$UNSPLASH_TERMS_OF_SERVICE_LINK = 'https://unsplash.com/terms'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$SearchContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1d1q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$SearchResultsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15zi _18m915zi _zulpu2gc _1e0c11p5 _c71l1sa4 _yv0e1d08 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$UnsplashWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1n7u _kqswh2mm _1bsb6ci3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$ImageResultsList = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1bgi",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$artistInfoSelector = 'items.ArtistInfo'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$ArtistInfo = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _bfhkmpja _mrkbfajl _1o0zfajl _kqswstnw _94n5idpf _1bsb1osq _tzy4kb7n _3um015vq _ak06ewfl",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$ArtistLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82",
            __cmplp.className
        ])
    });
});
$d53659c85faac35b$var$ArtistInfo.defaultProps = {
    'data-styled-selector': $d53659c85faac35b$var$artistInfoSelector
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$ArtistNameWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _18u01b66 _syaz15cr _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$baseImageStyles = {
    width: '100%',
    height: '77.93px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d53659c85faac35b$var$UnsplashImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsb1osq _4t3i1r1e",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$UnsplashImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _4t3i1r1e _12jivbh5 _jw7uewfl",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$UnsplashLegalTerms = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf _bfhkysee _mrkbfajl _1o0zfajl _syazazsu",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$LegalTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkze3t _2hwxu2gc _otyrze3t _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$UnderlinedLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz124n",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$EndofResultsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _1461g31l",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$UnsplashSearchErrorWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulppxbi _yyhyuojk _1e0c1txw _4t3i1jje _2lx21bp4 _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$SearchErrorText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$ImagePlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsb1osq _4t3i1r1e _bfhki8nm",
            __cmplp.className
        ])
    });
});
const $d53659c85faac35b$var$UnsplashLicenseLink = ()=>/*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnderlinedLink, {
        target: "_blank",
        href: $d53659c85faac35b$var$UNSPLASH_LICENSE_LINK,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashLicenseLink
        })
    });
const $d53659c85faac35b$var$UnsplashTermsOfServiceLink = ()=>/*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnderlinedLink, {
        target: "_blank",
        href: $d53659c85faac35b$var$UNSPLASH_TERMS_OF_SERVICE_LINK,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashTermsOfServiceLink
        })
    });
const $d53659c85faac35b$export$dab0686b1ddf2c98 = ({ unSplashSearchResults: unSplashSearchResults, id: id, idPrefix: idPrefix, handleImageSelection: handleImageSelection, loadMoreText: loadMoreText, queryWord: queryWord, pageNumber: pageNumber, setUnsplashSearchResults: setUnsplashSearchResults, handleError: handleError, searchResultsRef: searchResultsRef, unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall, dropdownPopupComponentRef: dropdownPopupComponentRef, isPageTitleComponent: isPageTitleComponent, analyticsSource: analyticsSource })=>{
    const [showButtonSpinner, setShowButtonSpinner] = (0, $42omo.useState)(false);
    const imageRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onImageClick = ({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        handleImageSelection({
            fullSizeImageUrl: fullSizeImageUrl,
            altDescription: altDescription,
            downloadLink: downloadLink
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'selected',
                actionSubject: 'image',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplashSearch'
                }
            }
        }).fire();
    };
    const onKeyDown = (e, result)=>{
        if (e.key === 'Enter' || e.key === ' ') onImageClick(result);
    };
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const onClickLoadMoreButton = ()=>{
        setShowButtonSpinner(true);
        pageNumber.current++;
        const defaultQueryWord = isPageTitleComponent ? (0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD);
        const queryKeyword = queryWord.current || defaultQueryWord;
        (0, $eNm9g.getUnsplashPhotos)(queryKeyword, pageNumber.current, submitError, isPageTitleComponent).then((results)=>{
            setUnsplashResultsCountFromLastAPICall(results.length);
            setUnsplashSearchResults(unSplashSearchResults.concat(results));
            setShowButtonSpinner(false);
            imageRef.current?.focus();
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'loadMoreUnsplashImagesButtonClicked',
                source: analyticsSource
            }
        }).fire();
    };
    const UnsplashLegalText = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$LegalTextWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashLegal,
                values: {
                    unsplashLicenseLink: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashLicenseLink, {}),
                    unsplashTermsOfServiceLink: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashTermsOfServiceLink, {})
                }
            })
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)($d53659c85faac35b$var$SearchContentContainer, {
        id: id,
        ref: dropdownPopupComponentRef,
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$SearchResultsContainer, {
                ref: searchResultsRef,
                children: unSplashSearchResults?.length ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$ImageResultsList, {
                            children: unSplashSearchResults.map((result, index)=>result ? /*#__PURE__*/ (0, $l998X.jsxs)($d53659c85faac35b$var$UnsplashWrapper, {
                                    "data-testid": `${idPrefix}-unsplash-image-${result.id}`,
                                    onKeyDown: (e)=>onKeyDown(e, result),
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashImageWrapper, {
                                            // assign ref to image result only when it is the first of 30 new images loaded more.
                                            // This ref is necessary for placing focus on the image result away from load more button
                                            ref: index === unSplashSearchResults.length - 30 ? imageRef : null,
                                            onClick: ()=>onImageClick(result),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashImage, {
                                                src: result.smallSizeImageUrl,
                                                alt: result.altDescription
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$ArtistInfo, {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$ArtistLink, {
                                                href: result.artistUrl,
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$ArtistNameWrapper, {
                                                    children: result.artistName
                                                })
                                            })
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashWrapper, {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$ImagePlaceholder, {
                                        "data-testid": "unsplash-popup-image-placeholder"
                                    })
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$EndofResultsWrapper, {
                            children: unsplashResultsCountFromLastAPICall === 30 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9YwaJ.default), {
                                onClick: onClickLoadMoreButton,
                                spacing: "compact",
                                isLoading: showButtonSpinner,
                                "aria-label": formatMessage((0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashLoadMoreAriaLabel),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...loadMoreText
                                })
                            }) : /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$SearchErrorText, {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashNoMoreResultsToLoadText
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsxs)($d53659c85faac35b$var$UnsplashSearchErrorWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5f0e5a5917169067$exports))),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$SearchErrorText, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $3b75a366b1d2a3f7$export$defe85febe8b728c).unsplashNoResultsText
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($d53659c85faac35b$var$UnsplashLegalTerms, {
                children: /*#__PURE__*/ (0, $l998X.jsx)(UnsplashLegalText, {})
            })
        ]
    });
};








const $faf1866ba556dd9a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    refinedUnsplashSearchPlaceholderText: {
        id: "company-hub.company-hub-common.refined.unsplash.search.placeholder",
        defaultMessage: "Browse Unsplash"
    },
    unsplashLoadMoreText: {
        id: "company-hub.company-hub-common.unsplash.search.load.more.unsplash.photos",
        defaultMessage: "Load more"
    },
    unsplashSearchAriaLabel: {
        id: "company-hub.company-hub-common.unsplash.search.aria-label",
        defaultMessage: "Search header images"
    }
});


const $9504dfe5e02bad40$var$iconContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $9504dfe5e02bad40$export$a7e261e3ec8ef2a0 = ({ elementIdPrefix: elementIdPrefix, unsplashSearchFieldId: unsplashSearchFieldId, handleImageSelection: handleImageSelection, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, defaultUnsplashResults: defaultUnsplashResults, setDefaultUnsplashResults: setDefaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const [unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall] = (0, $42omo.useState)(30);
    const searchResultsRef = (0, $42omo.useRef)(null);
    const pageNumber = (0, $42omo.useRef)(1);
    const textfieldInputValue = (0, $42omo.useRef)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const debouncedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((searchBar)=>{
        textfieldInputValue.current = searchBar?.value;
        const defaultQueryWord = isPageTitleComponent ? (0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD);
        const queryKeyword = textfieldInputValue.current || defaultQueryWord;
        setUnsplashSearchResults(Array(30).fill(null));
        (0, $eNm9g.getUnsplashPhotos)(queryKeyword, pageNumber.current, submitError, isPageTitleComponent).then((result)=>{
            if (!defaultUnsplashResults || defaultUnsplashResults.length === 0) setDefaultUnsplashResults(result);
            setUnsplashResultsCountFromLastAPICall(result.length);
            setUnsplashSearchResults(result);
            setError(undefined);
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'typed',
                actionSubject: 'headerImageSearch',
                actionSubjectId: 'headerImageSearchTyped',
                source: analyticsSource
            }
        }).fire();
    }, 350);
    const handleSearchOnChange = (event)=>{
        pageNumber.current = 1;
        debouncedQuery(event.target);
        searchResultsRef.current?.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleChange = ()=>{
        setIsPopupOpen(true);
    };
    const handleKeyDown = (event)=>{
        if ([
            'Enter',
            ' ',
            'ArrowUp',
            'ArrowDown'
        ].includes(event.key)) {
            if (event.key === ' ' && !textfieldInputValue.current) event.preventDefault();
            handleChange();
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        autoFocus: false,
        role: "dialog",
        onClose: ()=>setIsPopupOpen(false),
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $d53659c85faac35b$export$dab0686b1ddf2c98), {
                id: `${elementIdPrefix}-unsplash-popup-content`,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                unSplashSearchResults: unSplashSearchResults,
                idPrefix: elementIdPrefix,
                handleImageSelection: handleImageSelection,
                loadMoreText: (0, $faf1866ba556dd9a$export$defe85febe8b728c).unsplashLoadMoreText,
                queryWord: textfieldInputValue,
                pageNumber: pageNumber,
                setUnsplashSearchResults: setUnsplashSearchResults,
                handleError: handleError,
                searchResultsRef: searchResultsRef,
                unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall,
                setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall,
                isPageTitleComponent: isPageTitleComponent,
                analyticsSource: analyticsSource
            }),
        isOpen: isPopupOpen,
        placement: placement,
        testId: "unsplash-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                ...triggerProps,
                role: "combobox",
                "aria-expanded": isPopupOpen,
                "aria-controls": `${elementIdPrefix}-unsplash-popup-content`,
                "aria-label": formatMessage((0, $faf1866ba556dd9a$export$defe85febe8b728c).unsplashSearchAriaLabel),
                id: unsplashSearchFieldId,
                testId: `${elementIdPrefix}-unsplash-search-bar`,
                onChange: handleSearchOnChange,
                onClick: handleChange,
                onInput: handleChange,
                onKeyDown: (event)=>handleKeyDown(event),
                isDisabled: isUploadingImage || isDisabled,
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $9504dfe5e02bad40$var$iconContainerStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        label: "",
                        color: "currentColor"
                    })
                }),
                placeholder: formatMessage((0, $faf1866ba556dd9a$export$defe85febe8b728c).refinedUnsplashSearchPlaceholderText)
            })
    });
};
module.exports["UnsplashSearchBar"] = $9504dfe5e02bad40$export$a7e261e3ec8ef2a0;

});

parcelRegister("eVW6V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fOKpq = parcelRequire("fOKpq");


var $2Maq7 = parcelRequire("2Maq7");


var $eNm9g = parcelRequire("eNm9g");


var $iqWjJ = parcelRequire("iqWjJ");




const $35511bfd19956d09$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unsplashApiNoNetworkErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.search.error.no-network-message",
        defaultMessage: "We\u2019ve lost the connection. Try again."
    },
    unsplashApiBadStatusErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.error.bad-request-message",
        defaultMessage: "We can\u2019t get a response from Unsplash. Refresh and try again."
    },
    unsplashApiRateLimitedErrorMessage: {
        id: "company-hub.company-hub-common.unsplash.error.rate-limited-message",
        defaultMessage: "We can\u2019t get a response from Unsplash. Wait a moment, then try again."
    }
});


const $058e13bb9c3f0262$var$isBadStatusError = (error)=>error.message.includes('400');
const $058e13bb9c3f0262$var$isRateLimitedError = (error)=>error.message.includes('429');
var $058e13bb9c3f0262$export$d14ec7f08a14d421 = /*#__PURE__*/ function(UnsplashFetchError) {
    UnsplashFetchError["NO_NETWORK_ERROR"] = "network_error";
    UnsplashFetchError["RATE_LIMITED_ERROR"] = "rate_limited_error";
    UnsplashFetchError["BAD_STATUS_ERROR"] = "bad_status_error";
    return UnsplashFetchError;
}({});
const $058e13bb9c3f0262$var$i18nErrorText = {
    ["network_error"]: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $35511bfd19956d09$export$defe85febe8b728c).unsplashApiNoNetworkErrorMessage
    }),
    ["bad_status_error"]: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $35511bfd19956d09$export$defe85febe8b728c).unsplashApiBadStatusErrorMessage
    }),
    ["rate_limited_error"]: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $35511bfd19956d09$export$defe85febe8b728c).unsplashApiRateLimitedErrorMessage
    })
};
const $058e13bb9c3f0262$export$d0105baa5ed279b8 = (isPageTitleComponent, selectedImageUrl, initialUnsplashResults)=>{
    const [defaultUnsplashResults, setDefaultUnsplashResults] = (0, $42omo.useState)([]);
    const [unSplashSearchResults, setUnsplashSearchResults] = (0, $42omo.useState)([]);
    const [fetchError, setError] = (0, $42omo.useState)();
    const contentTopperDefaultImageUrl = (0, $iqWjJ.isUnsplashImage)(selectedImageUrl) ? selectedImageUrl : '';
    const selectedDefaultImageUrl = !isPageTitleComponent ? selectedImageUrl : contentTopperDefaultImageUrl;
    const handleError = (0, $42omo.useCallback)((error)=>{
        if ($058e13bb9c3f0262$var$isRateLimitedError(error)) setError("rate_limited_error");
        else if ($058e13bb9c3f0262$var$isBadStatusError(error)) setError("bad_status_error");
        else setError("network_error");
        setUnsplashSearchResults(undefined);
    }, [
        setError,
        setUnsplashSearchResults
    ]);
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    (0, $42omo.useEffect)(()=>{
        if (!initialUnsplashResults) {
            const defaultUnsplashQueryWord = isPageTitleComponent ? (0, $2Maq7.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD);
            (0, $eNm9g.getUnsplashPhotos)(defaultUnsplashQueryWord, 1, submitError, isPageTitleComponent).then((result)=>{
                setUnsplashSearchResults(result);
                setDefaultUnsplashResults(result);
            }).catch((responseError)=>{
                handleError(responseError);
            });
        } else {
            setUnsplashSearchResults(initialUnsplashResults);
            setDefaultUnsplashResults(initialUnsplashResults);
        }
    }, [
        initialUnsplashResults,
        isPageTitleComponent,
        handleError,
        submitError
    ]);
    return {
        selectedDefaultImageUrl: selectedDefaultImageUrl,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        errorMessage: fetchError ? $058e13bb9c3f0262$var$i18nErrorText[fetchError] : undefined,
        handleError: handleError,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        setError: setError
    };
};
module.exports["useUnsplash"] = $058e13bb9c3f0262$export$d0105baa5ed279b8;

});

parcelRegister("hY5v2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $bfgIy = parcelRequire("bfgIy");


var $hw7wB = parcelRequire("hw7wB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $3v7tz = parcelRequire("3v7tz");


var $jD7cj = parcelRequire("jD7cj");


var $jCIc5 = parcelRequire("jCIc5");


var $azUhE = parcelRequire("azUhE");


var $6YdGV = parcelRequire("6YdGV");


var $h3Ebw = parcelRequire("h3Ebw");


var $eVW6V = parcelRequire("eVW6V");




const $1cd6ae8d30eb9094$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    uploadMediaLabel: {
        id: "company-hub.company-hub-common.unsplash.upload.label",
        defaultMessage: "Upload"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9779db170c6dccc$var$UnsplashSearchFlexContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $d9779db170c6dccc$var$UploadButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_t74o1ylp _11381ylp",
            __cmplp.className
        ])
    });
});
const $d9779db170c6dccc$var$bottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $d9779db170c6dccc$var$removeBottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.0'
});
const $d9779db170c6dccc$export$7db48b229e0f0751 = ({ id: id, idPrefix: idPrefix, imageAltText: imageAltText, sectionLabel: sectionLabel, helperMessage: helperMessage, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, openMediaBrowser: openMediaBrowser, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, analyticsActionSubject: analyticsActionSubject, analyticsActionSubjectId: analyticsActionSubjectId, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, isNoImageAllowed: isNoImageAllowed, enableBottomSpacing: enableBottomSpacing = true })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDisabled = (0, $3v7tz.useIsDisabledContext)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $eVW6V.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const unsplashSearchFieldId = id ? `${idPrefix}-search-unsplash-${id}` : `${idPrefix}-search-unsplash`;
    const handleUploadButtonClick = ()=>{
        openMediaBrowser && openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: analyticsActionSubject,
                actionSubjectId: analyticsActionSubjectId,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)($d9779db170c6dccc$var$UnsplashSearchFlexContainer, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                htmlFor: unsplashSearchFieldId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                    showUpdatedStyles: true,
                    children: sectionLabel
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $azUhE.MediaContentHelperMessage), {
                helperMessage: helperMessage,
                isDisabled: isDisabled
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $h3Ebw.UnsplashSearchBar), {
                        unsplashSearchFieldId: unsplashSearchFieldId,
                        elementIdPrefix: idPrefix,
                        handleImageSelection: handleImageSelection,
                        analyticsSource: analyticsSource,
                        setDefaultUnsplashResults: setDefaultUnsplashResults,
                        defaultUnsplashResults: defaultUnsplashResults,
                        unSplashSearchResults: unSplashSearchResults,
                        setUnsplashSearchResults: setUnsplashSearchResults,
                        setError: setError,
                        handleError: handleError,
                        placement: placement,
                        dropdownPopupComponentRef: dropdownPopupComponentRef,
                        isUploadingImage: isUploadingImage
                    }),
                    !!openMediaBrowser && /*#__PURE__*/ (0, $l998X.jsx)($d9779db170c6dccc$var$UploadButtonWrapper, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            onClick: handleUploadButtonClick,
                            testId: "open-media-browser",
                            isDisabled: isUploadingImage || isDisabled,
                            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
                                    color: "currentColor",
                                    spacing: "spacious",
                                    label: ""
                                }),
                            label: intl.formatMessage((0, $1cd6ae8d30eb9094$export$defe85febe8b728c).uploadMediaLabel)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: enableBottomSpacing ? $d9779db170c6dccc$var$bottomSpacing : $d9779db170c6dccc$var$removeBottomSpacing,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6YdGV.DefaultImagePicker), {
                            contentId: contentId,
                            confluencePageId: confluencePageId,
                            initialUnsplashResults: defaultUnsplashResults?.slice(0, 5),
                            handleImageSelection: handleImageSelection,
                            imageAltText: imageAltText,
                            selectedImageUrl: selectedDefaultImageUrl,
                            analyticsSource: analyticsSource,
                            isUploadingImage: isUploadingImage,
                            isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $jD7cj.FormFieldErrorMessage), {
                        children: errorMessage
                    })
                ]
            })
        ]
    });
};
module.exports["UnsplashSearch"] = $d9779db170c6dccc$export$7db48b229e0f0751;

});


//# sourceMappingURL=cards-extension.ca47aa79.js.map
